<template>
	<div class="sub-file">
		<div class="sub-file-button flex-center-cross">
			<sub-button color="black" icon="upload" hollow @click="uploadHandle">上传文件</sub-button>
			<div v-if="word" class="sub-file-word">{{word}}</div>
		</div>
		
		<ul v-show="fileList.length">
			<li v-for="(item, i) in fileList" :key="i" class="flex"><span class="ellipsis">{{item}}</span><a @click="remove(i)">[删除]</a></li>
		</ul>
	</div>
</template>

<script>
	export default {
		props: {
			word: String,
			
			value: [String, Array],
			
			limit: {
				type: Number,
				default: 1
			},
			
			type: String
		},

		data() {
			return {
				fileList: []
			}
		},

		computed: {
			spare() {
				return this.fileList.length < this.limit;
			}
		},

		watch: {
			value() {
				this.update();
			},
			
			fileList(val) {
				this.$emit('input', this.limit == 1 ? (val[0] || '') : val);
			}
		},
		
		mounted() {
			this.update();
		},

		methods: {
			update() {
				this.fileList = this.value ? (typeof this.value == 'object' ? this.value : this.value.toString().split(',')) : [];
			},
			
			remove(i) {
				this.fileList.splice(i, 1);
			},

			uploadHandle() {
				this.sub.$upload({
					fileType: this.type,
					success: data => {
						if (this.limit == 1) {
							this.fileList = [data.filePath];
						} else {
							this.fileList.push(data.filePath);
						}
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.sub-file {
		&-button {
			height: 38px;
		}
		
		&-word {
			margin-left: 8px;
			line-height: 20px;
			font-size: 13px;
			color: #999;
		}
		
		ul {
			margin-top: 4px;
			
			li {
				line-height: 24px;
				font-size: 12px;
				color: #0030FF;
				
				span {
					max-width: 300px;
				}
				
				a {
					margin-left: 12px;
					white-space: nowrap;
					color: #f00;
				}
			}
		}
	}
</style>
